var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": _vm.maxWidth } },
    [
      _c("w-card-title", [_vm._v("Create an account")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-input", {
                    attrs: { label: "Bedrijfsnaam", fancy: "", required: "" },
                    model: {
                      value: _vm.companyname,
                      callback: function ($$v) {
                        _vm.companyname = $$v
                      },
                      expression: "companyname",
                    },
                  }),
                ],
                1
              ),
              _vm.$wf.isMdUp
                ? _c("w-col", { attrs: { xs: "12", md: "6", xl: "8" } })
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-input", {
                    attrs: { label: "Voornaam", fancy: "" },
                    model: {
                      value: _vm.firstname,
                      callback: function ($$v) {
                        _vm.firstname = $$v
                      },
                      expression: "firstname",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-input", {
                    attrs: { label: "Achternaam", fancy: "" },
                    model: {
                      value: _vm.lastname,
                      callback: function ($$v) {
                        _vm.lastname = $$v
                      },
                      expression: "lastname",
                    },
                  }),
                ],
                1
              ),
              _vm.$wf.isXl
                ? _c("w-col", { attrs: { xs: "12", md: "6", xl: "4" } })
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: "Email",
                      fancy: "",
                      required: "",
                      validators: [_vm.emailValidator],
                    },
                    model: {
                      value: _vm.email,
                      callback: function ($$v) {
                        _vm.email = $$v
                      },
                      expression: "email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-input", {
                    attrs: { label: "Telefoon", fancy: "" },
                    model: {
                      value: _vm.phone,
                      callback: function ($$v) {
                        _vm.phone = $$v
                      },
                      expression: "phone",
                    },
                  }),
                ],
                1
              ),
              _vm.$wf.isXl
                ? _c("w-col", { attrs: { xs: "12", md: "6", xl: "4" } })
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: "Wachtwoord",
                      fancy: "",
                      password: !_vm.showPassword,
                      required: "",
                      icon: "eye",
                    },
                    on: {
                      "icon-click": function ($event) {
                        _vm.showPassword = !_vm.showPassword
                      },
                    },
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: "Wachtwoord opnieuw",
                      fancy: "",
                      password: !_vm.showPassword,
                      required: "",
                      validators: [_vm.samePasswordValidator],
                    },
                    model: {
                      value: _vm.repeatPassword,
                      callback: function ($$v) {
                        _vm.repeatPassword = $$v
                      },
                      expression: "repeatPassword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c(
                    "w-button",
                    {
                      style: { flexGrow: 1 },
                      on: {
                        click: function ($event) {
                          return _vm.generateRandomPassword()
                        },
                      },
                    },
                    [_vm._v(" Willekeurig wachtwoord aanmaken ")]
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-date-picker", {
                    attrs: { fancy: "", label: "Actief tot" },
                    model: {
                      value: _vm.activeUntil,
                      callback: function ($$v) {
                        _vm.activeUntil = $$v
                      },
                      expression: "activeUntil",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", xl: "4" } },
                [
                  _c("w-date-picker", {
                    attrs: { nullable: "", fancy: "", label: "Aanmaak datum" },
                    model: {
                      value: _vm.dateCreated,
                      callback: function ($$v) {
                        _vm.dateCreated = $$v
                      },
                      expression: "dateCreated",
                    },
                  }),
                ],
                1
              ),
              _vm.$wf.isXl
                ? _c("w-col", { attrs: { xs: "12", md: "6", xl: "4" } })
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { xl: "4", md: "6", xs: "12" } },
                [
                  _c("w-select", {
                    attrs: { items: _vm.dbItems, fancy: "", label: "Database" },
                    model: {
                      value: _vm.dbId,
                      callback: function ($$v) {
                        _vm.dbId = $$v
                      },
                      expression: "dbId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: "Email verzenden met gebruikersnaam en wachtwoord",
                    },
                    model: {
                      value: _vm.notifyWithEmail,
                      callback: function ($$v) {
                        _vm.notifyWithEmail = $$v
                      },
                      expression: "notifyWithEmail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: "Gebruiker is standaard geactiveerd" },
                    model: {
                      value: _vm.userIsActive,
                      callback: function ($$v) {
                        _vm.userIsActive = $$v
                      },
                      expression: "userIsActive",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: "API Key aanmaken" },
                    model: {
                      value: _vm.createApiKey,
                      callback: function ($$v) {
                        _vm.createApiKey = $$v
                      },
                      expression: "createApiKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label:
                        "Boekhouder-firma (eigenaar krijgt portaal met klant-dossiers)",
                    },
                    model: {
                      value: _vm.isAccountant,
                      callback: function ($$v) {
                        _vm.isAccountant = $$v
                      },
                      expression: "isAccountant",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _vm.showCancelButton
            ? _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" Annuleren ")]
              )
            : _vm._e(),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: {
                icon: "plus",
                disabled: !_vm.isValid || _vm.createdCompanyId != 0,
              },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" Aanmaken ")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.createdApiKey != "" } },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "700" } },
            [
              _c("w-card-title", [_vm._v("API Key")]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(
                          " Kopieer en bewaar deze API-sleutel nu, want dit is de enige keer dat deze wordt weergegeven. "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c("w-col", { style: { flexGrow: 1, flexShrink: 1 } }, [
                        _vm._v(" " + _vm._s(_vm.createdApiKey) + " "),
                      ]),
                      _c(
                        "w-col",
                        { style: { flexShrink: 0 } },
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.copyApiKey()
                                },
                              },
                            },
                            [
                              _c("w-fa", { attrs: { icon: "copy" } }),
                              _vm._v(" Kopieer API-sleutel "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: {
                        disabled:
                          !_vm.apiKeyCopied || _vm.apiKeyContinueDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.apiKeyContinue()
                        },
                      },
                    },
                    [_vm._v(" Continue ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }